/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : HOME : STYLES --------------- ++++++++++ */
export default theme => ({
	home: {
        background: '#FDFDFE'
	}
});
